import {jwtDecode} from "jwt-decode";

export const getSessionMessage = (token: string) => {
    const decodedToken = jwtDecode(token) as {
        sub: string;
        iat: number;
        exp: number;
    };
    const expirationTime = decodedToken.exp * 1000;
    const currentTime = Date.now();
    const remainingTime = expirationTime - currentTime;
    const hours = Math.floor(remainingTime / (1000 * 60 * 60));
    const minutes = Math.floor(
        (remainingTime % (1000 * 60 * 60)) / (1000 * 60)
    );
    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
    return `Your session will expire in ${hours} hours, ${minutes} minutes, and ${seconds} seconds.`;
};